import React from "react";
import { DateTime } from 'luxon';
import PayMethod from "../../components/profilo/ListaPods/PayMethod";
import ConfermaBTN from '../../components/ConfermaBTN/ConfermaBTN';
import { useSelector } from "react-redux";
import md5 from "md5";

function InvoiceDetail(props) {
  console.log("🚀 ~ file: _InvoiceDetail.jsx ~ line 9 ~ InvoiceDetail ~ props", props)
  const { tag, data_emissione, importo, numero_fattura } = props.invoiceDetail;
  const saldoAttuale = useSelector((user) => user.user.currentBalance);
  const customerId = useSelector((user) => user.user.info.customer_id);
  const tknPvt = md5(customerId + 'oYmAIdtki%lu')
  const token = useSelector((user) => user.user?.datiPagamento?.token);
  

  const switchCausale = (tag) => {
    switch (tag) {
      case "fattura":
        return "Fattura";
      case "rai":
        return "Canone RAI";
      default:
        return "Altri Oneri";
    }
  };

  const switchUrl = () => {
      if(tag === 'rai' && saldoAttuale >= importo) {
        return `https://my.revoluce.it/area_utente/gestione/api/payments/payCanoneByCredit.php?tkn_pvt=${tknPvt}&customer_id=${customerId}&numero_fattura=${numero_fattura}&importo_fattura=${importo}`
      } else if( tag === 'rai' && saldoAttuale < importo) {
        return `https://my.revoluce.it/area_utente/gestione/api/payments/payCanone.php?token=${token}&tkn_pvt=${tknPvt}&customer_id=${customerId}&numero_fattura=${numero_fattura}&importo_fattura=${importo}`
      } else if( tag === 'fattura_oneri' && saldoAttuale >= importo){
        return `https://my.revoluce.it/area_utente/gestione/api/payments/payOnereByCredit.php?tkn_pvt=${tknPvt}&customer_id=${customerId}&entry_id=${numero_fattura}&importo=${importo}`
      } else {
        return `https://my.revoluce.it/area_utente/gestione/api/payments/pay_normale.php?amount=${importo}&token=${token}&customer_id=${customerId}&tkn_pvt=${tknPvt}`
      }
  }

  return (
    <div className="invoice-detail">
      <p className="main">Ecco un riepilogo della tua richiesta</p>
      <p className="secondary">Leggi e conferma la richiesta</p>
      <div className="causale">
        <p className="label">Causale</p>
        <p className="secondary">{switchCausale(tag)}</p>
      </div>
      <div className="date">
        <p className="label">Data</p>
        <p className="secondary">
          {DateTime.fromISO(data_emissione).toFormat("D")}
        </p>
      </div>
      <PayMethod />
      <span className="line"></span>
      <div className="amount">
        <p className="label">Da pagare:</p>
        <p className="main">{parseFloat(importo).toFixed(2).replace(/\./g, ",")} € <span className="etichetta">IVA esclusa</span></p>
      </div>
      <ConfermaBTN 
        forward="/enrica/richiesta-inoltrata" 
        text="Conferma pagamento" 
        confermTxt={`Procedere con il pagamento ${switchCausale(tag)} di € ${parseFloat(importo).toFixed(2).replace(/\./g, ",")} ?`}
        url={switchUrl()}
      />
      <div className="empty" style={{height: '100px'}}></div>
    </div>
  );
}

export default InvoiceDetail;
